module.exports = __webpack_public_path__ + "de66dc54045513cf3ea849fc6a2746c5.png";